module.exports = __WEBPACK_EXTERNAL_MODULE_37__;


//////////////////
// WEBPACK FOOTER
// external {"root":"angularResizableElement","commonjs":"angular-resizable-element","commonjs2":"angular-resizable-element","amd":"angular-resizable-element"}
// module id = 37
// module chunks = 0